import calculator from "../modules/calculator";
import overlay from "../modules/overlay";
import projects from "../modules/projects";

const templatePricing = {
  init: function () {
    overlay.init();
    calculator.init();
    projects.init();

    this.houses();
    this.scrollnav();
  },

  houses: function () {
    var housesNav = $(".houses-nav");
    var houses = $(".houses");
    $(".houses-nav__item", housesNav).click(function () {
      $(".active", housesNav).removeClass("active");
      $(this).addClass("active");
      $(".house.active", houses).removeClass("active");
      $(".house", houses).eq($(this).index()).addClass("active");
      houses.height($(".house.active", houses).outerHeight(true));
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: housesNav.offset().top - 30 - 80,
          },
          400
        );
      if ($(".house.active .swiper-container").length) {
        var mySwiper = document.querySelector(
          ".house.active .swiper-container"
        ).swiper;
        var thumbsSwiper = document.querySelector(
          ".house.active .thumbs-container"
        ).swiper;
        mySwiper.update();
        thumbsSwiper.update();
      }
    });
    $(".house:first", houses).addClass("active");
    houses
      .addClass("ready")
      .height($(".house.active", houses).outerHeight(true));
    setTimeout(function () {
      houses.height($(".house.active", houses).outerHeight(true));
    }, 1000);
    $(window).resize(function () {
      houses.height($(".house.active", houses).outerHeight(true));
    });
  },

  scrollnav: function () {
    $(".houses-nav__scrollable").scroll(function () {
      $(this).parent().addClass("scrolled");
    });
  },
};

export default templatePricing;
